<template>
    <v-dialog persistent v-model="showHighestQualifications" width="700" scrollable>
         <v-card>
           <!-- <loader v-if="showLoader"></loader> -->
           <v-card-title class="headline  lighten-2 border-bottom px-5"> 
               Qualifications
               <div class="spacer"></div>
               <CButtonClose @click="$emit('close')"/>    
           </v-card-title>
           <v-card-text class="addbox">
             <div>
                 <v-chip v-for="(qualification, i) in selectedQualifications" :key="i" class="mr-3 mb-4">
                   <span class="text-capitalize" >{{ qualification }}</span>
                </v-chip>
             </div>
           </v-card-text>
         </v-card>
       </v-dialog>
   </template>
   <script>
   export default {
     props: ["showHighestQualifications","selectedQualifications"],   
   };
   </script>
   <style lang="scss" scoped>
   .v-card__title{
       font-size:0.875rem!important;
   }
   </style>
   